import { render, staticRenderFns } from "./EvaluateRules.vue?vue&type=template&id=d4b36fb4&scoped=true&"
import script from "./EvaluateRules.vue?vue&type=script&lang=js&"
export * from "./EvaluateRules.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateRules.vue?vue&type=style&index=0&id=d4b36fb4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b36fb4",
  null
  
)

export default component.exports